export const REPORT_REASONS = [
  { value: "spam", label: "Spam" },
  { value: "harassment", label: "Harassment" },
  { value: "hate", label: "Hate / abusive content" },
  { value: "sexual", label: "Sexual / inappropriate content" },
  { value: "threats", label: "Threats" },
  { value: "scam", label: "Scam / fraud" },
  { value: "other", label: "Other" },
];

export const BAN_DURATIONS = [
  { value: "1h", label: "1 hour" },
  { value: "24h", label: "24 hours" },
  { value: "7d", label: "7 days" },
  { value: "permanent", label: "Permanent" },
];

export const reasonLabel = (v) => REPORT_REASONS.find((r) => r.value === v)?.label || v;

export const ACTION_LABELS = {
  dismissed: "Dismissed",
  message_deleted: "Message deleted",
  user_banned: "User banned",
};
